import { req } from "vuelidate/lib/validators/common";

export default (value: number) => {
  // Check if a value has been passed in
  if (!req(value)) {
    return true;
  }

  return Number(value) % 10 === 0;
};
